import ResourceUtils from "../../utils/resource-utils"
import { Attribute } from "../attribute.model"
import { ITSImage } from "../itsImage.model"
import { PremiumColors } from "./premiumColors.model"
import { PremiumFeaturedSection } from "./premiumFeaturedSection.model"
import { PremiumFooterSection } from "./premiumFooterSection.model"
import { PremiumSection } from "./premiumSection.model"

// TODO can we somehow consolidate the two modals, from a business logic standpoint, there is not so much difference between the two, we could reflect that in code to be more readable
export class PremiumHomePage {
    public hasFeaturedResources: boolean

    constructor(
        public id: number,
        public publish: boolean,
        public loId: string,
        public title: string,
        public metaTitle: string,
        public description: string,
        public credits: string,
        public hero: ITSImage,
        public heroGradient: boolean,
        public whiteLogo: ITSImage,
        public colorLogo: ITSImage,
        public attributions: Attribute[],
        public featuredSection: PremiumFeaturedSection,
        public sections: PremiumSection[],
        public footerSection: PremiumFooterSection,
        public resourceGrades: string[],
        public resourceMediaTypes: { [mediaType: string]: number },
        public colors: PremiumColors,
        public brands: string[],
        public contentProjects: string[],
        public topLevelSubjects: string[],
        public slug: string,
        public resourcesByLanguage: { [language: string]: number }
    ) {
        this.hasFeaturedResources =
            this.featuredSection &&
            this.featuredSection.learningObjects &&
            this.featuredSection.learningObjects.length > 0
    }

    public getAdminLink(): string {
        return `/admin/cms/collection/${this.id}`
    }

    public getFooterAttributions(): Attribute[] {
        // Hide business logic here for now.
        return this.attributions
    }

    public getResourceTypesDisplay(): string {
        return ResourceUtils.getResourceTypesDisplay(
            this.resourceMediaTypes,
            this.resourceGrades,
            this.resourcesByLanguage
        )
    }

    public static fromData(data): PremiumHomePage {
        const sections = (data.subcollections || []).map((section_data) =>
            PremiumSection.fromData(section_data)
        )
        const resourceTypes = data.resources_info || {}
        return new PremiumHomePage(
            data.id,
            data.publish,
            data.lo_id,
            data.title,
            data.display_meta_title || data.title,
            data.description,
            data.credits,
            new ITSImage(data.hero, data.hero_alt_text),
            data.hero_gradient,
            new ITSImage(data.white_logo, data.white_logo_alt_text),
            new ITSImage(data.color_logo, data.color_logo_alt_text),
            Attribute.fromDataArray(data.attributions || []),
            PremiumFeaturedSection.fromData(data.featured_resources || {}),
            sections,
            data.footer_links ? PremiumFooterSection.fromData(data.footer_links) : null,
            resourceTypes.grades || [],
            resourceTypes.media_types || {},
            new PremiumColors(data.style_content),
            data.brands,
            data.content_projects,
            data.top_level_subjects,
            data.slug,
            resourceTypes.resources_by_language
        )
    }
}
